<!--
 * @Description: 
 * @Author: huangshiwen
 * @Date: 2022-06-06 13:25:07
 * @LastEditTime: 2022-06-06 14:02:09
-->
<template>
    <Common>
      <template slot="common">
          <ModifyPwd />
      </template>
    </Common>
</template>

<script>
import ModifyPwd from "@/components/hospitalModifyPwd/modifyPwd"
export default{
  components:{
   ModifyPwd
  },
  
  data(){
    return {

    }
  },
  created(){

  }
}
</script>
<style lang="less" scoped>

</style>